<template>
  <v-tooltip bottom :disabled="!owner || disableTooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        v-if="owner"
        small
        v-bind="attrs"
        v-on="on"
        class="ma-0 mt-1"
        style="max-width: fit-content"
        :class="[{ 'cursor-pointer': clickable }]"
        @click="emitClick"
      >
        <img
          class="broker-avatar-image"
          :class="iconOnly ? '' : 'mr-1'"
          :src="getBrokerLogoPath(owner)"
          alt="Broker"
        />
        <span v-if="!iconOnly" class="pr-1">
          {{ label || owner || unknownLabel }}
        </span>
      </v-chip>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { getBrokerLogoPath } from "@/utils/brokers";

export default {
  props: {
    owner: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    disableTooltip: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "Owner",
    },
    unknownLabel: {
      type: String,
      default: "Desconhecido",
    },
  },
  methods: {
    emitClick() {
      if (this.clickable) this.$emit("click");
    },
    getBrokerLogoPath(owner) {
      return getBrokerLogoPath(owner);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-chip__content {
  cursor: default !important;
  padding: 0 4px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.broker-avatar-image {
  width: 20px !important;
  height: 20px !important;
}
</style>
